import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export class ClickOutsideContainer extends Component {
    constructor(props) {
        super(props);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside (evt) {
        const domNode = ReactDOM.findDOMNode(this);

        if (!domNode || !domNode.contains(evt.target)) {
            this.props.onClickOutside(evt);
        } 
    }

    render() {
        return this.props.children;
    }
}

ClickOutsideContainer.propTypes = {
    children: PropTypes.element.isRequired,
    onClickOutside: PropTypes.func.isRequired
};

export default ClickOutsideContainer;


// WEBPACK FOOTER //
// ./src/сomponents/ClickOutsideContainer/index.js